import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { CreateTransferDto, TransferDto } from '../types';

export const useCreateTransfer = () => {
  const { projectId } = useParams();

  const queryClient = useQueryClient();

  return useMutation<TransferDto, Error, CreateTransferDto>({
    mutationFn: (data) => apiClient.post(`/v1/projects/${projectId}/transfers`, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transfers', projectId] });
    },
  });
};
